export default "__VITE_ASSET__PHT9EfG7__"